<template>
  <div class="text-container">
     <p class="heading4">404, Here is not hidden moon. Please select route from navigation menu.</p> 
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.text-container {
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.heading4 {
    padding: 0 3rem;
}
</style>